export default {
    donationGroupList: [],
    donationGroupListCount: 0
}